import { FrontApp } from './modules/app';

/**
 * Front app を起動する.
 *
 * @return void
 */
const bootstrapFrontApp = (): void => {
	const app = new FrontApp();
	app.init();
};

if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', bootstrapFrontApp );
} else {
	bootstrapFrontApp();
}
